/* ============================================================
   รายการไฟล์แนบ (ใช้ทั้งหน้าพนักงานและ portal ลูกค้า)
   <FileList files={[...]} onOpen={(file, inline) => ...} actions={(file) => [<Button/>]} />
============================================================ */
import React from "react";
import { Button, Empty, List, Space, Tooltip, Typography } from "antd";
import {
  DownloadOutlined,
  EyeOutlined,
  FileExcelOutlined,
  FileImageOutlined,
  FileOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FileZipOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { canPreview, formatSize } from "../../utils/fileOpen";

export const FileIcon = ({ file, size = 22 }) => {
  const m = file?.mime || "";
  const n = (file?.file_name || "").toLowerCase();
  const st = { fontSize: size };
  if (m === "application/pdf") return <FilePdfOutlined style={{ ...st, color: "#d4380d" }} />;
  if (m.startsWith("image/")) return <FileImageOutlined style={{ ...st, color: "#389e0d" }} />;
  if (/\.(docx?)$/.test(n)) return <FileWordOutlined style={{ ...st, color: "#1d39c4" }} />;
  if (/\.(xlsx?)$/.test(n)) return <FileExcelOutlined style={{ ...st, color: "#237804" }} />;
  if (/\.zip$/.test(n)) return <FileZipOutlined style={{ ...st, color: "#8c8c8c" }} />;
  return <FileOutlined style={{ ...st, color: "#9b6420" }} />;
};

export default function FileList({ files = [], onOpen, actions, emptyText = "ยังไม่มีไฟล์", showDate = true, showTitle = true, size = "small" }) {
  if (!files.length) return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={emptyText} />;
  return (
    <List
      size={size}
      dataSource={files}
      renderItem={(f) => (
        <List.Item
          className="ak-file-item"
          actions={[
            canPreview(f.mime) && (
              <Tooltip title="เปิดดู" key="v">
                <Button size="small" icon={<EyeOutlined />} onClick={() => onOpen(f, true)} />
              </Tooltip>
            ),
            <Tooltip title="ดาวน์โหลด" key="d">
              <Button size="small" icon={<DownloadOutlined />} onClick={() => onOpen(f, false)} />
            </Tooltip>,
            ...(actions ? actions(f) : []),
          ].filter(Boolean)}
        >
          <List.Item.Meta
            avatar={<FileIcon file={f} />}
            title={
              <Typography.Link onClick={() => onOpen(f, canPreview(f.mime))} className="ak-file-name">
                {showTitle && f.title ? `${f.title} · ` : ""}
                {f.file_name}
              </Typography.Link>
            }
            description={
              <Space size={6} wrap style={{ fontSize: 12 }}>
                <span>{formatSize(f.file_size)}</span>
                {showDate && f.created_date && <span>· {dayjs(f.created_date).format("DD/MM/YYYY HH:mm")}</span>}
                {f.uploaded_name && <span>· {f.uploaded_name}</span>}
                {f.remark && <span>· {f.remark}</span>}
              </Space>
            }
          />
        </List.Item>
      )}
    />
  );
}
